import { NgSignaturePadOptions, SignaturePadComponent } from '@almothafar/angular-signature-pad';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ProfileService } from '../services/profile/profile.service';
import { User } from '../models/user';
import { ConfirmDialogComponent } from '../material-component/confirm-dialog/confirm-dialog.component';
import { DialogData } from '../models/dialog-data';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { ProfileSection } from '../constants/profile-section';
import { FormUtils } from '../utils/form-utils';
import { TokenStorageService } from '../services/token-storage/token-storage.service';
import { ApplicationService } from '../services/application.service';
import { DownloadService } from '../services/download/download.service';

@Component({
  selector: 'app-basic-profile',
  templateUrl: './basic-profile.component.html',
  styleUrls: ['./basic-profile.component.css']
})
export class BasicProfileComponent implements OnInit {
  currentProfile: User | undefined;

  addressForm = new FormControl('');
  noTelpForm = new FormControl('');
  hpForm = new FormControl('');
  emailDinasForm = new FormControl('');
  emailPribadiForm = new FormControl('');
  uploadFileForm = new FormControl();

  imgSrc = '';
  imageRealpath: string | undefined = '';
  showSignature = false;
  isLoading = false;
  showSave = true;
  tandaTangan: string | undefined;
  @ViewChild('signature') public signaturePad:
    | SignaturePadComponent
    | undefined;

  signaturePadOptions: NgSignaturePadOptions = {
    // passed through to szimek/signature_pad constructor
    minWidth: 2,
    canvasWidth: 300,
    canvasHeight: 200,
  };
  onDestroy$ = new Subject<void>();
  ProfileSection = ProfileSection;
  FormUtils = FormUtils;

  constructor(private profileService: ProfileService,
    private dialog: MatDialog,
    private tokenStorageService: TokenStorageService,
    private applicationService: ApplicationService,
    private downloadService: DownloadService,
    private matDialogRef: MatDialogRef<BasicProfileComponent>) { }

  ngOnInit(): void {
    this.profileService.currentProfile$.pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.currentProfile = data;

        this.addressForm.setValue(this.currentProfile.address);
        this.noTelpForm.setValue(this.currentProfile.noTelp);
        this.hpForm.setValue(this.currentProfile.phone);
        this.emailDinasForm.setValue(this.currentProfile.emailDinas);
        this.emailPribadiForm.setValue(this.currentProfile.email);
        this.imgSrc = '/assets/images/users/' + (this.currentProfile.gender?.id === 1 ? 'male-pp.jpg' : 'female-pp.jpg');
        this.tandaTangan = this.currentProfile.tandaTangan;
        this.imageRealpath = this.currentProfile.photo;
        if (this.imageRealpath) {
          this.imgSrc = this.downloadService.downloadUrl(5, this.imageRealpath!);
        }
      });

    let id = this.tokenStorageService.getId();
    this.applicationService.currentProfileId$.next(id);
    this.profileService.loadUser(id);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onSubmit() {
    this.save(ProfileSection.KONTAK_PRIBADI);
  }

  save(section: string) {
    if (this.currentProfile) {
      const user: User = this.currentProfile;
      if (section === ProfileSection.KONTAK_PRIBADI) {
        user.address = this.addressForm.value;
        user.noTelp = this.noTelpForm.value;
        user.phone = this.hpForm.value;
        user.email = this.emailPribadiForm.value;
        user.emailDinas = this.emailDinasForm.value;
        user.tandaTangan = this.tandaTangan;
        user.photo = this.imageRealpath;
      }
      this.profileService.update(section, user).subscribe((res) => {
        if (res) {
          if (this.imageRealpath) {
            this.imgSrc = this.downloadService.downloadUrl(5, this.imageRealpath!);
            this.applicationService.profilePicture = this.imgSrc;
          }
          this.displayInfo('Perubahan data berhasil disimpan');
        }
      });
    }
  }

  displayInfo(message: string) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: <DialogData>{
        title: 'Informasi',
        message: message,
        okLabel: 'OK',
        isConfirmation: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        dialogRef.close();
      }
    });
  }

  /** start signature **/
  clearSignature() {
    this.signaturePad?.clear();
    this.tandaTangan = '';
  }

  editSignature() {
    this.showSignature = true;
    this.showSave = false;
  }

  saveSignature() {
    if (!this.signaturePad?.isEmpty()) {
      this.tandaTangan = this.signaturePad?.toDataURL();
    }
    this.showSignature = false;
    this.showSave = true;
  }

  /** end of signature **/

  selectFile(event: any): void {
    if (event.target.files.length > 0) {
      // this.isUploading = true;
      this.uploadFileForm = new FormControl();
      this.profileService.upload('', event.target.files, 'profile-picture').subscribe((data) => {
        // this.isUploading = false;
        // this.displayInfo('Perubahan data berhasil disimpan');
        if (data.dataObjects) {
          this.imageRealpath = data.dataObjects[0];
          this.imgSrc = this.downloadService.downloadUrl(5, this.imageRealpath!);
        }
      });
    }
  }

}
